import { CorporateCustomer } from "../../models/CorporateApplication";
import { Box, Grid, MenuItem, TextField } from "@mui/material";
import CountryFlag from "../checkout/CountryFlag";
import {
    CANADA_ID,
    CountryOptions,
    OtherProvinceOptions,
    StateOptions,
    US_ID,
} from "../../models/AddressFormSelections";
import { ProvinceOptions } from "../../utils/addressFormSelections";

type Props = {
    customer: CorporateCustomer;
    countryId: number | null;
    stateId: number | null;
    onCustomerFieldChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onContactFieldChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onCountryChange: (e: React.ChangeEvent<any>) => void;
    onStateChange: (e: React.ChangeEvent<any>) => void;
};

const CustomerDetailsForm = ({
    customer,
    countryId,
    stateId,
    onCustomerFieldChange,
    onContactFieldChange,
    onCountryChange,
    onStateChange,
}: Props) => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField
                    label="Partner Name"
                    variant="standard"
                    name="corporationName"
                    fullWidth
                    required={true}
                    value={customer.corporationName}
                    onChange={onCustomerFieldChange}
                />
            </Grid>
            <Grid item xs={12} lg={6}>
                <TextField
                    label="Contact First Name"
                    variant="standard"
                    name="firstName"
                    fullWidth
                    required={true}
                    value={customer.contact.firstName}
                    onChange={onContactFieldChange}
                />
            </Grid>
            <Grid item xs={12} lg={6}>
                <TextField
                    label="Contact Last Name"
                    variant="standard"
                    name="lastName"
                    fullWidth
                    required={true}
                    value={customer.contact.lastName}
                    onChange={onContactFieldChange}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    label="Contact Title"
                    variant="standard"
                    name="title"
                    fullWidth
                    required={false}
                    value={customer.contact.title}
                    onChange={onContactFieldChange}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    label="Contact Department"
                    variant="standard"
                    name="department"
                    fullWidth
                    required={false}
                    value={customer.contact.department}
                    onChange={onContactFieldChange}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    label="Contact Email"
                    variant="standard"
                    name="email"
                    type="email"
                    fullWidth
                    required={true}
                    value={customer.contact.email}
                    onChange={onContactFieldChange}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    label="Contact Phone"
                    variant="standard"
                    name="phone"
                    type="tel"
                    fullWidth
                    required={true}
                    value={customer.contact.phone}
                    onChange={onContactFieldChange}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    label="Fax"
                    variant="standard"
                    name="fax"
                    fullWidth
                    required={false}
                    value={customer.fax}
                    onChange={onCustomerFieldChange}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    label="Address"
                    variant="standard"
                    name="address"
                    fullWidth
                    required={true}
                    value={customer.address}
                    onChange={onCustomerFieldChange}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    label="City"
                    variant="standard"
                    name="city"
                    fullWidth
                    required={true}
                    value={customer.city}
                    onChange={onCustomerFieldChange}
                />
            </Grid>
            <Grid item xs={12} lg={6}>
                <TextField
                    label="Country"
                    variant="standard"
                    name="countryId"
                    fullWidth
                    select
                    required={true}
                    value={countryId}
                    onChange={onCountryChange}
                >
                    {CountryOptions().map((c) => (
                        <MenuItem key={c.id} value={c.id}>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                }}
                            >
                                <CountryFlag abbreviation={c.abbreviation} />
                                {c.name}
                            </Box>
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
            <Grid item xs={12} lg={6}>
                <TextField
                    label="Province/State"
                    variant="standard"
                    name="stateId"
                    fullWidth
                    select
                    required={true}
                    value={stateId}
                    onChange={onStateChange}
                >
                    {countryId === CANADA_ID &&
                        ProvinceOptions().map((p) => (
                            <MenuItem key={p.id} value={p.id}>
                                {p.name}
                            </MenuItem>
                        ))}
                    {countryId === US_ID &&
                        StateOptions().map((s) => (
                            <MenuItem key={s.id} value={s.id}>
                                {s.name}
                            </MenuItem>
                        ))}
                    {countryId !== CANADA_ID &&
                        countryId !== US_ID &&
                        OtherProvinceOptions().map((o) => (
                            <MenuItem key={o.id} value={o.id}>
                                {o.name}
                            </MenuItem>
                        ))}
                </TextField>
            </Grid>
            <Grid item xs={12}>
                <TextField
                    label={countryId === US_ID ? "ZIP Code" : "Postal Code"}
                    variant="standard"
                    name="postalCode"
                    fullWidth
                    required={true}
                    value={customer.postalCode}
                    onChange={onCustomerFieldChange}
                />
            </Grid>
        </Grid>
    );
};

export default CustomerDetailsForm;
